export const COUNTRIES = [
  {
    code: "RS",
    name: "Srbija",
    dialCode: "381",
    flag: "🇷🇸",
    placeholder: "0641234567",
  },
  {
    code: "HR",
    name: "Hrvatska",
    dialCode: "385",
    flag: "🇭🇷",
    placeholder: "0912345678",
  },
  {
    code: "BA",
    name: "Bosna i Hercegovina",
    dialCode: "387",
    flag: "🇧🇦",
    placeholder: "061234567",
  },
  {
    code: "ME",
    name: "Crna Gora",
    dialCode: "382",
    flag: "🇲🇪",
    placeholder: "0681234567",
  },
  {
    code: "MK",
    name: "Severna Makedonija",
    dialCode: "389",
    flag: "🇲🇰",
    placeholder: "0701234567",
  },
  {
    code: "SI",
    name: "Slovenija",
    dialCode: "386",
    flag: "🇸🇮",
    placeholder: "0641234567",
  },
  {
    code: "HU",
    name: "Mađarska",
    dialCode: "36",
    flag: "🇭🇺",
    placeholder: "0701234567",
  },
  {
    code: "RO",
    name: "Rumunija",
    dialCode: "40",
    flag: "🇷🇴",
    placeholder: "0701234567",
  },
  {
    code: "BG",
    name: "Bugarska",
    dialCode: "359",
    flag: "🇧🇬",
    placeholder: "0701234567",
  },
  {
    code: "AT",
    name: "Austrija",
    dialCode: "43",
    flag: "🇦🇹",
    placeholder: "0601234567",
  },
  {
    code: "CH",
    name: "Švajcarska",
    dialCode: "41",
    flag: "🇨🇭",
    placeholder: "0761234567",
  },
  {
    code: "DE",
    name: "Nemačka",
    dialCode: "49",
    flag: "🇩🇪",
    placeholder: "01501234567",
  },
  {
    code: "IT",
    name: "Italija",
    dialCode: "39",
    flag: "🇮🇹",
    placeholder: "3201234567",
  },
  {
    code: "FR",
    name: "Francuska",
    dialCode: "33",
    flag: "🇫🇷",
    placeholder: "0601234567",
  },
  {
    code: "ES",
    name: "Španija",
    dialCode: "34",
    flag: "🇪🇸",
    placeholder: "0601234567",
  },
  {
    code: "PT",
    name: "Portugalija",
    dialCode: "351",
    flag: "🇵🇹",
    placeholder: "0912345678",
  },
  {
    code: "GR",
    name: "Grčka",
    dialCode: "30",
    flag: "🇬🇷",
    placeholder: "2101234567",
  },
  {
    code: "TR",
    name: "Turska",
    dialCode: "90",
    flag: "🇹🇷",
    placeholder: "0501234567",
  },
  {
    code: "UA",
    name: "Ukrajina",
    dialCode: "380",
    flag: "🇺🇦",
    placeholder: "0501234567",
  },
  {
    code: "PL",
    name: "Poljska",
    dialCode: "48",
    flag: "🇵🇱",
    placeholder: "0501234567",
  },
  {
    code: "CZ",
    name: "Češka",
    dialCode: "420",
    flag: "🇨🇿",
    placeholder: "0601234567",
  },
  {
    code: "SK",
    name: "Slovačka",
    dialCode: "421",
    flag: "🇸🇰",
    placeholder: "0901234567",
  },
  {
    code: "NL",
    name: "Holandija",
    dialCode: "31",
    flag: "🇳🇱",
    placeholder: "0601234567",
  },
  {
    code: "BE",
    name: "Belgija",
    dialCode: "32",
    flag: "🇧🇪",
    placeholder: "0401234567",
  },
  {
    code: "LU",
    name: "Luksemburg",
    dialCode: "352",
    flag: "🇱🇺",
    placeholder: "0601234567",
  },
  {
    code: "IE",
    name: "Irska",
    dialCode: "353",
    flag: "🇮🇪",
    placeholder: "0851234567",
  },
  {
    code: "GB",
    name: "Ujedinjeno Kraljevstvo",
    dialCode: "44",
    flag: "🇬🇧",
    placeholder: "07401234567",
  },
  {
    code: "SE",
    name: "Švedska",
    dialCode: "46",
    flag: "🇸🇪",
    placeholder: "0701234567",
  },
  {
    code: "NO",
    name: "Norveška",
    dialCode: "47",
    flag: "🇳🇴",
    placeholder: "41234567",
  },
  {
    code: "DK",
    name: "Danska",
    dialCode: "45",
    flag: "🇩🇰",
    placeholder: "20123456",
  },
  {
    code: "FI",
    name: "Finska",
    dialCode: "358",
    flag: "🇫🇮",
    placeholder: "0401234567",
  },
  {
    code: "LT",
    name: "Litvanija",
    dialCode: "370",
    flag: "🇱🇹",
    placeholder: "0601234567",
  },
  {
    code: "LV",
    name: "Latvija",
    dialCode: "371",
    flag: "🇱🇻",
    placeholder: "20123456",
  },
  {
    code: "EE",
    name: "Estonija",
    dialCode: "372",
    flag: "🇪🇪",
    placeholder: "5001234567",
  },
  {
    code: "BY",
    name: "Belorusija",
    dialCode: "375",
    flag: "🇧🇾",
    placeholder: "0251234567",
  },
  {
    code: "MD",
    name: "Moldavija",
    dialCode: "373",
    flag: "🇲🇩",
    placeholder: "0601234567",
  },
  {
    code: "US",
    name: "SAD",
    dialCode: "1",
    flag: "🇺🇸",
    placeholder: "2011234567",
  },
  {
    code: "CA",
    name: "Kanada",
    dialCode: "1",
    flag: "🇨🇦",
    placeholder: "2011234567",
  },
  {
    code: "AU",
    name: "Australija",
    dialCode: "61",
    flag: "🇦🇺",
    placeholder: "0212345678",
  },
  {
    code: "NZ",
    name: "Novi Zeland",
    dialCode: "64",
    flag: "🇳🇿",
    placeholder: "0212345678",
  },
  {
    code: "JP",
    name: "Japan",
    dialCode: "81",
    flag: "🇯🇵",
    placeholder: "09012345678",
  },
  {
    code: "KR",
    name: "Južna Koreja",
    dialCode: "82",
    flag: "🇰🇷",
    placeholder: "01012345678",
  },
  {
    code: "TH",
    name: "Tajland",
    dialCode: "66",
    flag: "🇹🇭",
    placeholder: "0812345678",
  },
  {
    code: "SG",
    name: "Singapur",
    dialCode: "65",
    flag: "🇸🇬",
    placeholder: "81234567",
  },
  {
    code: "HK",
    name: "Hong Kong",
    dialCode: "852",
    flag: "🇭🇰",
    placeholder: "91234567",
  },
  {
    code: "IN",
    name: "Indija",
    dialCode: "91",
    flag: "🇮🇳",
    placeholder: "9012345678",
  },
  {
    code: "PK",
    name: "Pakistan",
    dialCode: "92",
    flag: "🇵🇰",
    placeholder: "03001234567",
  },
  {
    code: "IL",
    name: "Izrael",
    dialCode: "972",
    flag: "🇮🇱",
    placeholder: "0501234567",
  },
  {
    code: "AE",
    name: "UAE",
    dialCode: "971",
    flag: "🇦🇪",
    placeholder: "0501234567",
  },
  {
    code: "SA",
    name: "Saudijska Arabija",
    dialCode: "966",
    flag: "🇸🇦",
    placeholder: "0501234567",
  },
  {
    code: "JO",
    name: "Jordan",
    dialCode: "962",
    flag: "🇯🇴",
    placeholder: "0791234567",
  },
  {
    code: "MX",
    name: "Meksiko",
    dialCode: "52",
    flag: "🇲🇽",
    placeholder: "5501234567",
  },
  {
    code: "BR",
    name: "Brazilija",
    dialCode: "55",
    flag: "🇧🇷",
    placeholder: "11912345678",
  },
  {
    code: "AR",
    name: "Argentina",
    dialCode: "54",
    flag: "🇦🇷",
    placeholder: "0111234567",
  },
  {
    code: "ZA",
    name: "Južna Afrika",
    dialCode: "27",
    flag: "🇿🇦",
    placeholder: "0712345678",
  },
  {
    code: "EG",
    name: "Egipat",
    dialCode: "20",
    flag: "🇪🇬",
    placeholder: "01001234567",
  },
  {
    code: "NG",
    name: "Nigerija",
    dialCode: "234",
    flag: "🇳🇬",
    placeholder: "08012345678",
  },
];
